
export default function closeSession() {
    // Get the token from localStorage
    const token = localStorage.getItem('token');
  
    // Check if the token exists
    if (token) {
      // Remove the token from localStorage
      localStorage.removeItem('token');
    }
  
    // Limpiar todos los datos de sessionStorage
    sessionStorage.clear();
  
    // Redirect the user to the login page
    window.location.href = '/';
  }